export const ErrorConstant = {
    default: 'Something went wrong',
}

export const LoginState = {
    init: 'init',
    processing: 'processing',
    error: 'error',
    success: 'success',
}
export const CommonConstant = {
    defaultPageSize: 20,
    mode: process.env.REACT_APP_MODE,
    maxBonus: 10 ** 18,
    totemChart: 'https://coinmarketcap.com/currencies/totem-new-earth-systems/',
    nullTx: '0x0000000000000000000000000000000000000000000000000000000000000000',
    nullAddress: '0x0000000000000000000000000000000000000000',
    nativeAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
}

export const PaginationType = {
    All: 'All',
    Default: 'Default',
}

export const StorageConstant = {
    token: 'token',
    user: 'user',
}

// Impersonation stash lives in sessionStorage (never localStorage): tokens are
// sensitive and must not survive a tab-close.
export const ImpersonationStorage = {
    adminToken: 'preImpersonationToken',
    adminUser: 'preImpersonationUser',
    session: 'impersonationSession',
}

// ErrorCode values returned by the impersonation endpoints.
export const ImpersonationErrorCode = {
    ReasonRequired: 'ReasonRequired',
    TargetNotFound: 'TargetNotFound',
    TargetInactive: 'TargetInactive',
    SelfImpersonation: 'SelfImpersonation',
    TargetCredentialFetchFailed: 'TargetCredentialFetchFailed',
    TargetValidateFailed: 'TargetValidateFailed',
    TokenGenerateFailed: 'TokenGenerateFailed',
    NotSuperAdmin: 'NotSuperAdmin',
    AlreadyImpersonating: 'AlreadyImpersonating',
    KillSwitchOff: 'KillSwitchOff',
    BlockedDuringImpersonation: 'BlockedDuringImpersonation',
    ImpersonationExpired: 'ImpersonationExpired',
}

export const DefaultChartKeyFields = {
    unAnswered: 'UnAnswered',
}
export const StatusType = {
    Created: 1,
    Save: 2,
    Down: 8,
    Completed: 5,
}

export const AccessOptions = [
    { Id: 'Public', name: 'Make it Public Template' },
    { Id: 'Private', name: 'Make it Private Template' },
    { Id: 'Internal', name: 'Make it Internal Template' },
    { Id: 'Special', name: 'Make It Special Template' },
]

export const ThemeRadioIds = {
    Image: 1,
    Text: 2,
}

export const ThemeRadioOptions = [
    { Id: ThemeRadioIds.Image, name: 'Image' },
    { Id: ThemeRadioIds.Text, name: 'Text' },
]

export const TaskGroupSectionsByDates = {
    Today: { key: 'today', title: 'Today' },
    Tomorrow: { key: 'tomorrow', title: 'Tomorrow' },
    ThisWeek: { key: 'thisWeek', title: 'This Week' },
    Later: { key: 'later', title: 'Later' },
}

export const TaskGroupSectionsByStatus = {
    InProgress: 'In Progress',
    Overdue: 'Overdue',
}
export const UserSteps = {
    Invite: 2,
}
export const InviteType = {
    Email: 1,
    Phone: 2,
}

export const CommanReportComponentType = {
    CompanyLogo: 1,
    AboutUs: 2,
    CompanyHeader: 3,
    ReportCustomerDetail: 4,
    ReportLocationDetail: 5,
    ChartResult: 6,
    SectionResult: 7,
    TextAreaWithEditor: 8,
    TextboxWithBulletPoint: 9,
    ImagePickup: 10,
    TableSummary: 11,
    TextBoxWithHeader: 12,
}

export const RegExesList = {
    Email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.(com|in)$/,
}

export const ChartRadioStatus = {
    None: 0,
    Pie: 1,
    Bar: 2,
}

export const AcceptFileType = {
    image: {
        'image/*': ['.jpeg', '.png', '.jpg', '.gif'],
    },
    video: {
        'video/*': [
            '.mp4',
            '.webm',
            '.wav',
            '.mp3',
            '.ogg',
            '.glb',
            '.gltf',
            '.mov',
        ],
    },
    imageVideo: {
        'image/*': [
            '.jpeg',
            '.png',
            '.jpg',
            '.gif',
            '.mp4',
            '.webm',
            '.wav',
            '.mov',
            '.mp3',
            '.ogg',
            '.glb',
            '.gltf',
        ],
    },
    document: {
        'application/pdf': ['.pdf'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            '.xlsx',
            '.csv',
        ],
    },
    xlsx: {
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            '.xlsx',
        ],
    },
    all: {
        'application/pdf': ['.pdf'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            '.xlsx',
            '.csv',
        ],
        'image/*': [
            '.jpeg',
            '.png',
            '.jpg',
            '.gif',
            '.mp4',
            '.webm',
            '.wav',
            '.mov',
            '.mp3',
            '.ogg',
            '.glb',
            '.gltf',
        ],
        'video/*': [
            '.mp4',
            '.webm',
            '.wav',
            '.mp3',
            '.ogg',
            '.glb',
            '.gltf',
            '.mov',
        ],
    },
}

export const DatePickerTypes = {
    Range: 'range',
    Single: 'single',
}

export const SettingsTabs = {
    User: 'user',
    Company: 'company',
    Report: 'report',
    AccountPlan: 'account-plan',
    Theme: 'theme',
    TemplateGroup: 'template-group',
    Announcement: 'announcement',
    SettingInvoice: 'setting-invoice',
    InvoiceRules: 'invoice-rules',
    CompanyMenuPermission: 'company-menu-permission',
    InvoicePrefix: 'invoice-prefix',
    UserMenuPermission: 'user-menu-permission',
    MenuPermission: 'menu-permission',
    ImpersonationHistory: 'impersonation-history',
    EscalationPolicies: 'escalation-policies',
    TicketCategories: 'ticket-categories',
    CorrectiveActionTickets: 'corrective-action-tickets',
    HomeDashboard: 'home-dashboard',
    VoiceInspection: 'voice-inspection',
}

export const FormErrorText = {
    SpacesNotAllowed: 'Spaces not alllowed',
}

export const QueryString = {
    customeReport: 'customeReport',
}

/** Temporary: hide Report Approval Turn 1/2 mockup screens and entry points. */
export const SHOW_REPORT_APPROVAL_FLOW = false
